import React, {Component} from "react"
import {browserHistory, Link} from "react-router"
import {Button, Card, Col, FormField, FormInput, FormSelect, Row, Modal, ModalHeader, ModalBody, ModalFooter, Spinner} from "elemental"
import {translate} from "translate"
import shop from "../../shop/shop"
import store from "store"
import {checkCartSize, checkMinCartValue} from "./check"
import "./CheckoutPage.scss"

export default class DeliveryPage extends Component {
	constructor() {
		super()
		this.state = {
			loading         : false,
			locations       : [],
			locationSelected: null,
			comment         : shop.cart.data.comment || "",
			modalOpened     : false,
			tempAddressIndex: 0,
			tempAddress     : {
				mapid   : "tempAddress0",
				name1   : "",
				name2   : "",
				name3   : "",
				street  : "",
				pcode   : "",
				city    : "",
				country : "",
				company : "",
				addition: "",
			}
		},

			this.handleAddressFieldChange = this.handleAddressFieldChange.bind( this );
	}

	handleAdressChoice = () => {
		const tempAddress = this.state.tempAddress
		const nextTempAddressIndex = this.state.tempAddressIndex + 1;

		if ( store.get( "tempAdresses" ) ) {
			store.set( "tempAddresses", [tempAddress, ...store.get( "tempAdresses" )] )
		} else {
			store.set( "tempAddresses", [tempAddress] )
		}

		shop.cart.setAddress( {location: tempAddress} )

		this.setState( {
			locations       : [tempAddress, ...this.state.locations],
			locationSelected: tempAddress.mapid,
			modalOpened     : false,
			tempAddressIndex: nextTempAddressIndex,
			tempAddress     : {
				mapid   : `tempAddress${nextTempAddressIndex}`,
				company : "",
				name1   : "",
				name2   : "",
				name3   : "",
				street  : "",
				pcode   : "",
				city    : "",
				country : "",
				addition: "",
			}
		} )
	}

	toggleModal = ( toggle = false ) => {
		this.setState( {modalOpened: toggle} )
	}

	handleAddressFieldChange = ( evt ) => {
		const tempAddress = this.state.tempAddress;
		tempAddress[evt.target.name] = evt.target.value;

		this.setState( {tempAddress} )
	}

	handleLocationSelect = ( location ) => {
		console.log( `set`, location )
		this.setState( {locationSelected: location.mapid} )
		shop.cart.setAddress( {location} )
	}

	handleCommentChange = ( event ) => {
		let comment = event.target.value
		this.setState( {comment} )
		shop.cart.setComment( {comment} )
	}

	componentDidMount() {
		let ok = checkCartSize()
		ok = ok && checkMinCartValue()
		if ( !ok ) return

		shop.fetch( "data/customers/current/addresses/deliver" )
			.then( locations => {
				if ( locations.length < 1 ) {
					console.warn( "Keine Versandadressen vorhanden" )
					return
				}

				let locationsWithTemporaryAdresses = store.get( "tempAddresses" ) ? [...store.get( "tempAddresses" ), ...locations] : locations
				// let locationSelected = locationsWithTemporaryAdresses[ 0 ].mapid

				// shop.cart.setAddress( { location: locationsWithTemporaryAdresses[ 0 ] } )

				this.setState( {
					locations       : locationsWithTemporaryAdresses,
					locationSelected: shop.cart.data.deliveraddress && shop.cart.data.deliveraddress.mapid
				} )
			} )
	}

	render() {
		let {locations, locationSelected, tempAddress, modalOpened} = this.state
		let {comment, deliveraddress, deliverdate, manual_order_id, print_receipt, comment_internal} = shop.cart.data

		let billingAddress = shop.session.value || {}
		console.log( {DeliveryPage: this} )
		return (
			<div className="">

				{/*HEADER STATE*/}
				<section>
					<Row className="top-bar tc">
						<Col sm="1/3"><Link to={"/checkout"}>1. {translate( "cart.cart" )} </Link></Col>
						<Col sm="1/3"><Link to={"/checkout/delivery"}><strong>2. {translate( "cart.address" )}</strong></Link></Col>
						<Col sm="1/3"><Link to={"/checkout/confirmation"}>3. {translate( "cart.check_and_submit" )}</Link></Col>
					</Row>
				</section>

				<section className="container">
					<h2>2. {translate( "address.address" )}</h2>
					<p>{translate( "Bitte wählen Sie eine Lieferadresse aus:" )}</p>
					<Row>

						<Col md="1/5" className=""><span className="black-50">{translate( "billing address" )}</span>
							<div className="pt3">
								<strong> {billingAddress.title}</strong> <br />
								{billingAddress.street} <br />
								{billingAddress.pcode} {billingAddress.city}<br />
								{billingAddress.country}<br />
							</div>
						</Col>
						<Col md="1/5" className=""><span className="black-50">{translate( "delivery address" )} </span>
							<div className="pt3">
								{!deliveraddress && <div>{translate( "billing address" )}</div>}
								{deliveraddress && <div>
									<div className="mb4">
										<strong>{deliveraddress.title} {deliveraddress.name1} {deliveraddress.name2} {deliveraddress.name3}</strong><br />
										{deliveraddress.street}<br />
										{deliveraddress.pcode} {deliveraddress.city}<br />
										{deliveraddress.country}<br />
									</div>
								</div>}
							</div>
						</Col>
						<Col md="1/5" className=""><span className="black-50">{translate( "payment" )} </span>
							<div className="pt3">
								<strong>wie vereinbart</strong>
							</div>
						</Col>
						<Col md="1/5" className=""><span className="black-50">{translate( "your message" )}
							<div className="pt3">
                  <p className="mb4">{comment ? comment : "-"}</p>
              </div>
              </span></Col>
					</Row>

					<hr />
				</section>

				<section className="container">
					<h2>{translate( "delivery" )}</h2>
					{locations.length > 0 ?
						<Adresses onChange={this.handleLocationSelect}
								  locations={locations}
								  locationSelected={locationSelected} /> : null}

					<TemporaryAddress temporaryAddress={tempAddress}
									  modalOpened={modalOpened}
									  handleModal={this.toggleModal}
									  handleChange={this.handleAddressFieldChange}
									  handleAddressChoice={this.handleAdressChoice} />
				</section>

				<section className="container">
					<Row>
						<Col sm="2/3">
							<FormField label={translate( "Kommentar" )}
									   htmlFor="supported-controls-input">
								<FormInput placeholder={translate( "Kommentar" )}
										   value={this.state.comment}
										   onChange={this.handleCommentChange}
										   multiline />
							</FormField>
						</Col>
					</Row>
				</section>


				<section className="pa2 mb4 bg-silver">
					<div className="container">
						<Row>
							<Col xs="1/2"
								 className="tl fl checkout-control">
								<Link to="/checkout">
									<Button type="link">
										<i className="icon-angle-left" />
										Zurück
									</Button>
								</Link>
							</Col>

							<Col xs="1/2"
								 className="tr fr checkout-control">
								<Button
									onClick={async () => {
										this.setState( {loading: true} )
										await shop.cart.save()
										this.setState( {loading: false} )
										browserHistory.push( "/checkout/confirmation" )

									}}
									type="primary">
									{translate( "cart.check_and_submit" )}
									<i className="icon-angle-right" />
								</Button>
							</Col>
						</Row>
					</div>
				</section>
			</div>
		)
	}
}

const Adress = ( {location, handleSelect, isSelected, title} ) => {
	const mapid = location.mapid || ""
	return (
		<div>
			<h3>{mapid.indexOf( "tempAddress" ) !== -1 && "Eingegebene"} {title || translate( "Lieferanschrift" )}</h3>
			{location.company} <br />
			{location.title} {location.name1} {location.name2} {location.name3}<br />
			{location.street} <br />
			{location.addition} <br />
			{location.pcode} {location.city}<br />
			{location.country}<br />
			{isSelected ? <Button className="mt3" type="primary" onClick={() => handleSelect( location )}>{translate( "shop.selected" )}</Button> :
				<Button className="mt3" onClick={() => handleSelect( location )}>{translate( "shop.select" )}</Button>}
			{/*<pre>{JSON.stringify(location, null, 2)}</pre>*/}
		</div>
	)
}


const Adresses = ( {locations, locationSelected, onChange} ) => {
	let addresses = locations.map( ( location, key ) => {
		let isSelected = locationSelected === location.mapid
		return (<Col key={key} sm="1/3"><Card>
			<Adress isSelected={isSelected} handleSelect={onChange} location={location} /></Card>
		</Col>)
	} )
	return <Row>
		{/*BILLING ADDRESS */}
		<Col key={"invoice_address"} sm="1/3"><Card><Adress
			title={translate( "billing address" )}
			isSelected={locationSelected === location.mapid}
			handleSelect={() => {
				onChange( false )
			}
			}
			location={shop.session.value || {}} /></Card></Col>
		{addresses}</Row>
}

const TemporaryAddress = ( {handleModal, handleChange, handleAddressChoice, temporaryAddress, modalOpened} ) => {
	return (
		<div>
			<Modal isOpen={modalOpened} onCancel={() => handleModal( false )} backdropClosesModal>
				<ModalHeader text={`${translate( "shop.add_new_address" )}`} showCloseButton onClose={() => handleModal( false )} />
				<ModalBody>
					<TemporaryAddressForm handleChange={handleChange} temporaryAddress={temporaryAddress} />
				</ModalBody>
				<ModalFooter>
					<Button type="primary" onClick={() => handleAddressChoice()}>{translate( "shop.add" )}</Button>
					<Button className="fr" type="link-cancel" onClick={() => handleModal( false )}>{translate( "shop.close" )}</Button>
				</ModalFooter>
			</Modal>


			{/*<Row>*/}
			{/*<Col sm="1">*/}
			{/*<Button className="mt2" onClick={() => handleModal( true )}>{translate( "shop.add" )}</Button>*/}
			{/*</Col>*/}
			{/*</Row>*/}
		</div>
	)
}

const TemporaryAddressForm = ( {temporaryAddress, handleChange} ) => {
	return (
		<form>
			<Row>
				<Col sm="1/3">
					<FormField label={translate( "address.salutation" )} htmlFor="name1">
						<FormSelect
							firstOption=" "
							name="name1"
							options={[
								{label: 'Herr', value: 'Herr'},
								{label: 'Frau', value: 'Frau'}
							]} onChange={( value ) => {
							let fakeEvent = {target: {name: "name1", value}}
							handleChange( fakeEvent )
						}} />
					</FormField>
				</Col>
				<Col sm="1/3">
					<FormField label={translate( "address.first_name" )} htmlFor="name2">
						<FormInput type="text" name="name2" value={temporaryAddress.name2} onChange={handleChange} />
					</FormField>

				</Col>
				<Col sm="1/3">
					<FormField label={translate( "address.surname" )} htmlFor="name3">
						<FormInput type="text" name="name3" value={temporaryAddress.name3} onChange={handleChange} />
					</FormField>
				</Col>
			</Row>

			<FormField label={translate( "address.company" )} htmlFor="company">
				<Row>
					<Col sm="1">
						<FormInput type="text" name="company" placeholder={translate( "address.company" )} value={temporaryAddress.company}
								   onChange={handleChange} />
					</Col>
				</Row>
			</FormField>

			<Row>
				<Col sm="1">
					<FormField label={translate( "address.street" )} htmlFor="street">
						<FormInput type="text" name="street" placeholder={translate( "address.street" )} value={temporaryAddress.street}
								   onChange={handleChange} />
					</FormField>
				</Col>
			</Row>

			<Row>
				<Col sm="1">
					<FormField label={translate( "address.addition" )} htmlFor="addition">
						<FormInput type="text" name="addition" placeholder={translate( "address.addition" )} value={temporaryAddress.addition}
								   onChange={handleChange} />
					</FormField>
				</Col>
			</Row>

			<Row>
				<Col sm="1/5">
					<FormField label={translate( "address.pcode" )} htmlFor="pcode">
						<FormInput type="text" name="pcode" placeholder={translate( "address.pcode" )} value={temporaryAddress.pcode}
								   onChange={handleChange} />
					</FormField>
				</Col>
				<Col sm="4/5">
					<FormField label={translate( "address.city" )} htmlFor="city">
						<FormInput type="text" name="city" placeholder={translate( "address.city" )} value={temporaryAddress.city} onChange={handleChange} />
					</FormField>
				</Col>
			</Row>

			<FormField label={translate( "address.country" )} htmlFor="country">
				<Row>
					<Col sm="1">
						<FormInput type="text" name="country" placeholder={translate( "address.country" )} value={temporaryAddress.country}
								   onChange={handleChange} />
					</Col>
				</Row>
			</FormField>
		</form>
	)
}



// WEBPACK FOOTER //
// ./src/pages/checkout/DeliveryPage.js